import BasePopupStore from "@state/stores/popups/BasePopupStore";
import { observable, action } from "mobx";
import type { RootStore } from "@state/stores/types";
import { StorageStateKeysEnum } from "@utils/storage";
import { DeviceDetector } from "@utils";

class XtremepushNotificationPermissionPopupStore extends BasePopupStore {
	@observable isNotificationsEnabled: boolean = false;
	@observable shouldAskForPermission: boolean = false;
	@observable permission: string | undefined = undefined;

	constructor(rootStore: RootStore) {
		super(rootStore);
	}

	@action.bound
	onInitialize() {
		const popupDelay = 5000;

		if (WEBPACK_IS_NOTIFICATIONS_ENABLED) {
			this.isNotificationsEnabled = true;
		}

		const xtremepushData = JSON.parse(
			this.rootStore.localStorageProvider.get(
				StorageStateKeysEnum.XTREMEPUSH
			) as string
		);

		if (xtremepushData === null) {
			return;
		}

		if (
			xtremepushData.permission == "default" ||
			xtremepushData.permission == undefined
		) {
			this.shouldAskForPermission = true;
		}

		if (this.isNotificationsEnabled && this.shouldAskForPermission) {
			setTimeout(() => {
				this.triggerPopup();
			}, popupDelay);
		}
	}

	@action.bound
	triggerPopup() {
		if (
			window.location.pathname.includes("home") ||
			window.location.pathname.includes("sports") ||
			window.location.pathname.includes("live")
		) {
			if (DeviceDetector.isDesktopSafari) {
				this.activatePopup();
				this.shouldAskForPermission = false;
			} else {
				this.activatePrompt();
				this.shouldAskForPermission = false;
			}
		}
	}

	@action.bound
	activatePrompt() {
		//@ts-expect-error
		xtremepush("ready", function () {
			//@ts-expect-error
			const permission = xtremepush("push", "permission");

			if (permission == "default") {
				//@ts-expect-error
				xtremepush("push", "prompt", {
					allowCallback: function () {
						window.location.reload();
					},
				});
			}
		});
	}

	@action.bound
	onAllow() {
		this.deactivatePopup();
		//@ts-expect-error
		xtremepush("ready", function () {
			//@ts-expect-error
			const permission = xtremepush("push", "permission");

			if (permission == "default") {
				//@ts-expect-error
				xtremepush("push", "prompt", {
					allowCallback: function () {
						window.location.reload();
					},
				});
			}
		});
	}
}

export default XtremepushNotificationPermissionPopupStore;
